import { LocalStorageService } from "./local-storage-service.util";

export const isAuthenticated = () =>
  LocalStorageService.getAccessToken() && LocalStorageService.getRefreshToken();
